import { createFileRoute } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import AccountsPage from '@/settings/pages/accounts';

export const Route = createFileRoute('/settings/_layout/accounts/')({
  head: () => ({
    meta: routeMetadata('Accounts')
  }),
  component: AccountsRoute,
  staticData: {
    headerSection: null
  }
});

function AccountsRoute() {
  return <AccountsPage/>;
}
